export default __webpack_public_path__ + "static/media/section7_image.a0799829.svg";